<template>
  <section class="credits-section">
    <div class="st-sources" v-if="credits.source">
      <strong v-if="lang!=='zh-CN'" class="credits-label">Source:&nbsp;</strong>
      <strong v-if="lang==='zh-CN'" class="credits-label">来源:&nbsp;</strong>
      <span v-markdown="credits.source" />
    </div>
    <div class="st-other-source" v-if="credits.othersource">
      <span v-markdown="credits.othersource" />
    </div>
    <div v-if="credits.producedby">
      <strong v-if="lang!=='zh-CN'" class="credits-label">Produced by:&nbsp;</strong>
      <strong v-if="lang==='zh-CN'" class="credits-label">制作:&nbsp;</strong>
      <span itemprop="author" v-for="(item, i) in credits.producedby" :key="i" v-markdown="item"></span>
    </div>
    <div class="st-credits-remarks" v-if="credits.remarks">
      <span v-markdown="credits.remarks" />
    </div>
  </section>
</template>

<script>
export default {
  props: ['credits', 'lang']
}
</script>

<style lang="scss">
.credits-section {
  @include container;

  color: #666666;
  font-size: 13px;
  margin-top: 70px;
  border-top: dotted #ccc 1px;
  box-sizing: content-box;
  font-family: $font-CuratorRegular;
  padding: 20px $outerSpacingMobile 30px;

  @include breakpoint($d_medium) {
    padding: 20px $outerSpacing 30px;
  }

  div {
    line-height: 22px;
  }

  .st-sources {
    margin-bottom: 15px;
  }
  .st-other-source {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .st-credits-remarks {
    margin-top: 15px;
  }

  .credits-label {
    font-family: $font-CuratorBold;
  }

  [itemprop="author"]::after {
    content: ", ";
  }

  [itemprop="author"]:nth-last-child(2)::after {
    content: " ";
  }

  [itemprop="author"]:last-child::before {
    content: "and ";
  }

  [itemprop="author"]:only-of-type::before {
    content: "";
  }

  [itemprop="author"]:last-child::after {
    content: ".";
  }

  strong {
    font-family: $font-CuratorBold;
  }
}
</style>
